import { useMantineColorScheme } from '@mantine/core';
import { useEffect } from 'react';

import { useAuthStore } from '@/stores/authStore.ts';
import { ColorTheme, useThemeStore } from '@/stores/themeStore.ts';

import { getSavedTheme, toggleTailwindTheme } from '@/utils/themeUtils.ts';

const useTheme = (): void => {
    const { colorScheme: color_scheme, setColorScheme } = useMantineColorScheme();
    const is_user_set = useAuthStore((state) => state.is_user_set);
    const is_admin = useAuthStore((state) => state.is_admin);

    // Set theme to dark by default for admin
    useEffect(() => {
        if (!is_user_set || !is_admin) return;
        const saved_theme = getSavedTheme();
        if (!saved_theme) setColorScheme('dark');
    }, [is_user_set, is_admin]);

    useEffect(() => {
        const color_theme = color_scheme as ColorTheme;
        useThemeStore.setState({ theme: color_theme });
        toggleTailwindTheme(color_theme);
    }, [color_scheme]);
};

export default useTheme;
